import { render, staticRenderFns } from "./swDiagram.vue?vue&type=template&id=1ed2978a&scoped=true"
import script from "./swDiagram.vue?vue&type=script&lang=js"
export * from "./swDiagram.vue?vue&type=script&lang=js"
import style0 from "./swDiagram.vue?vue&type=style&index=0&id=1ed2978a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2978a",
  null
  
)

export default component.exports